import { Link } from '@tanstack/react-router';
import { Compass } from 'lucide-react';
import type { JSX } from 'react';
import { Button } from '@/components/ui/button.js';
import { EmptyState } from '@/components/ui/empty-state.js';

/** `notFoundComponent` global — un onglet mal orthographié ou une route pas encore livrée ne doit jamais afficher une page blanche (`02` §0). */
export function NotFoundPage(): JSX.Element {
  return (
    <div className="flex min-h-[60vh] items-center justify-center bg-background p-6">
      <EmptyState
        icon={<Compass aria-hidden="true" />}
        title="Page introuvable"
        description="Cet écran n'existe pas ou n'est pas encore disponible."
        action={
          <Button asChild variant="outline">
            <Link to="/">Retour au tableau de bord</Link>
          </Button>
        }
      />
    </div>
  );
}
